import { useQuery } from '@tanstack/react-query';
import { getContext } from '@dvag/dfs-orchestrator-client';
import { familyApprovalTwoFaApi } from 'service/api/familyApprovalTwoFaApi';
import { useNotification } from 'utils/notification/NotificationContext';
import i18next from 'i18next';

export const useGetCustomerPortalStatus = (householdId: string) => {
  const advisorId = getContext()?.user?.advisor.id;

  const customerPortalService = familyApprovalTwoFaApi();
  const { showDefault } = useNotification();

  return useQuery({
    queryKey: [`customer-portal-status-${householdId}`],
    queryFn: async () => {
      try {
        const response = await customerPortalService.kundanzuganHaushaltDetailApi({
          householdId,
          advisorId,
        });
        return response.data || [];
      } catch {
        showDefault({
          title: i18next.t('general.toasters.loading.customerPortal.errorDescription'),
          noTitle: false,
        });
        return [];
      }
    },
    enabled: !!advisorId && !!householdId,
    retry: false,
  });
};
